import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { DependencyFilterKeys } from '../../../../shared/dependenciesV2';
import * as DependenciesV2Store from '../../../redux/dependenciesV2';
import { SearchInput } from '../../generic';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../generic/Button';

import useFetchDependencyAction from './hooks/useFetchDependencyAction';
import type { DependencyV2Modals } from './hooks/useDependencyModals';

import styles from './dependencies.module.less';

type Props = {
  depModals: DependencyV2Modals;
};

const DependenciesHeader: VoidFunctionComponent<Props> = ({ depModals: { addDependencyModal } }) => {
  const setSearchFilterAndFetch = useFetchDependencyAction(DependenciesV2Store.actions.setFilters);
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const isProjectScope = useSelector(DependenciesV2Store.selectors.getIsProjectScope);
  const isOrgMember = useSelector(DependenciesV2Store.selectors.getIsOrgMember);

  const handleSearchInput = (value: string) => setSearchFilterAndFetch({
    ...filters,
    [DependencyFilterKeys.Title]: value,
  });

  return (
    <div className={styles.DependenciesHeader}>
      <div className={styles.DependenciesHeaderSearch}>
        <SearchInput
          label="dependency-name"
          placeholder="Filter by name or locator"
          size="medium"
          value={filters.title}
          onChange={handleSearchInput}
        />
      </div>
      {isOrgMember && isProjectScope && (
        <Button type={BUTTON_TYPE.SECONDARY} size={BUTTON_SIZE.LARGE} onClick={() => addDependencyModal.onOpen({ context: { mode: 'new' } })}>
          Add Dependency
        </Button>
      )}
    </div>
  );
};

export default DependenciesHeader;
